import { randomString } from '../lib/random-string';
import { BoxFile } from '../services/box.service';
import { DropboxFile } from '../services/dropbox.service';
import { GoogleDriveFile } from '../services/google-drive.service';
import { FromUrlFile } from '../services/upload-from-url.service';

export type UploadFile = File | DropboxFile | GoogleDriveFile | FromUrlFile | BoxFile;

export type UploadObjError =
  | 'general'
  | 'invalid-file-type'
  | 'cancelled'
  | 'cant-read-file'
  | 'wrong-type'
  | 'file-too-big'
  | 'failed-to-upload'
  | 'failed-to-create-asset'
  | 'resource_missing'
  | 'unprocessable_entity';

export interface UploadTimingPart {
  started_at: number;
  finished_at: number;
  size: number;
}

export class UploadObj {
  file: UploadFile;
  status: 'waiting' | 'started' | 'done' | 'error' = 'waiting';
  error: UploadObjError;
  uploadId: string;
  progress = 0;
  galleryId: string;
  sectionId: string;
  // startTime: number;
  // endTime: number;
  position: number;
  cancelled = false;
  description?: string;
  overrideName?: string;
  id = randomString(12);
  timings: {
    created_at: number;
    asset_creation_started_at?: number;
    asset_creation_finished_at?: number;
    upload_started_at?: number;
    upload_finished_at?: number;
    finished_at?: number;
    parts?: UploadTimingPart[];
  } = {
    created_at: Date.now(),
  };

  constructor(file: File, galleryId: string, sectionId?: string, position?: number) {
    this.file = file;
    this.galleryId = galleryId;
    this.sectionId = sectionId;
    this.position = position;
  }
}
